import React from 'react';
import { useGroupMasterList } from './hooks/useGroupMasterList';
import { WEEKLY_OFF_OPTIONS, SECOND_WEEKLY_OFF_OPTIONS } from './api/groupMasterApi';
import GroupMasterTable from './components/GroupMasterTable';
import AppPagination from '../../../components/AppPagination';
import SharedFilters from '../../../components/SharedFilters';

export default function EmployeeGroupListScreen() {
  const { state, actions } = useGroupMasterList();

  const statusTabs = [
    { key: 'Active', label: 'Active' },
    { key: 'Inactive', label: 'Inactive' },
    { key: 'All', label: 'All' },
  ];

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            Employee Group
          </h1>
          <p className="mt-1 text-xs text-on-surface-variant font-medium">
            Manage employee groups with weekly off and second weekly off configurations.
          </p>
        </div>

        {/* Actions Cluster: Segmented Status Tabs (No local Add button; use global Top Navbar '+ Create New') */}
        <div className="flex items-center gap-1.5 p-1 rounded-2xl bg-surface-container-high w-fit shadow-xs">
          {statusTabs.map((tab) => {
            const isActive = state.statusFilter === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => actions.handleStatusTabChange(tab.key)}
                className={`px-5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer select-none ${
                  isActive
                    ? 'bg-primary text-on-primary shadow-sm'
                    : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-container-highest/60'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </section>

      {/* Shared Filters Component */}
      <SharedFilters
        searchField="Name"
        searchText={state.searchText}
        setSearchText={actions.setSearchText}
        statusFilter={state.statusFilter}
        showStatus={false}
        weeklyOffFilter={state.weeklyOffFilter}
        setWeeklyOffFilter={actions.setWeeklyOffFilter}
        weeklyOffOptions={WEEKLY_OFF_OPTIONS}
        secondWeeklyOffFilter={state.secondWeeklyOffFilter}
        setSecondWeeklyOffFilter={actions.setSecondWeeklyOffFilter}
        secondWeeklyOffOptions={SECOND_WEEKLY_OFF_OPTIONS}
        visibleAccordionFilters={['weeklyOff', 'secondWeeklyOff']}
        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}
      />

      {/* Table Section */}
      <section className="space-y-4">
        <GroupMasterTable
          records={state.records}
          isLoading={state.isLoading}
          onArchive={actions.handleArchive}
          onDelete={actions.handleDelete}
          onResetFilters={actions.resetFilters}
        />

        {/* Pagination Footer */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>
    </div>
  );
}
